import React from "react";
import { PropTypes } from "prop-types";
import { MrbPage, MrbPageHeader } from "mrb/components/layout";
import { MrbDatePicker } from "mrb/components/date-picker";
import { MrbButton } from "mrb/components/button";
import { observer } from "mobx-react";

function ProducerReportLayoutTemplate({ producerReportViewStore, backButtonRenderer, children, t }) {
    return (
        <MrbPage>
            <MrbPageHeader>
                <Header
                    producerReportViewStore={producerReportViewStore}
                    backButtonRenderer={backButtonRenderer}
                    t={t}
                />
            </MrbPageHeader>

            {children}
        </MrbPage>
    );
}

ProducerReportLayoutTemplate.propTypes = {
    producerReportViewStore: PropTypes.object.isRequired,
    backButtonRenderer: PropTypes.any,
    children: PropTypes.any,
};

const Header = observer(function Header({ producerReportViewStore, backButtonRenderer, t }) {
    const {
        summaryData,
        isDateRangeDisabled,
        queryUtility,
        setFromDate,
        setToDate,
        applyFilter,
        maxDate,
        minToDate,
        maxFromDate,
        reportDownloadInProgress,
        fetchProducerReportCsv,
    } = producerReportViewStore;
    return (
        <React.Fragment>
            {backButtonRenderer && (
                <React.Fragment>{summaryData ? backButtonRenderer({ summaryData }) : <div></div>}</React.Fragment>
            )}
            <div className="c-header__actions">
                <div className="u-display--flex u-display--flex--ai--center">
                    {isDateRangeDisabled && (
                        <p className="u-type--sml u-mar--right--sml u-type--color--warning">
                            Maximum selection range is 6 months.
                        </p>
                    )}

                    <MrbButton
                        onClick={fetchProducerReportCsv}
                        disabled={reportDownloadInProgress || isDateRangeDisabled}
                        label="Download Report"
                        t={t}
                        classNameExtend="u-mar--right--sml"
                    />
                    <MrbDatePicker
                        value={queryUtility.filter.from}
                        isClearable={false}
                        selectsEnd={false}
                        maxDate={maxFromDate}
                        timeZone={queryUtility.filter.timeZone}
                        dateFormat="MM/dd/yyyy"
                        onChange={setFromDate}
                        showMonthYearPicker={false}
                        todayButtonLabel={null}
                        classNameExtend={isDateRangeDisabled ? "u-type--color--warning" : ""}
                    />
                    <span className="u-mar--right--tny u-mar--left--tny">-</span>

                    <MrbDatePicker
                        value={queryUtility.filter.to}
                        isClearable={false}
                        selectsEnd={true}
                        maxDate={maxDate}
                        minDate={minToDate}
                        timeZone={queryUtility.filter.timeZone}
                        dateFormat="MM/dd/yyyy"
                        onChange={setToDate}
                        showMonthYearPicker={false}
                        todayButtonLabel={null}
                    />

                    <MrbButton
                        t={t}
                        className="c-btn c-btn--base c-btn--primary u-mar--left--sml"
                        onClick={applyFilter}
                        label="Apply"
                        disabled={isDateRangeDisabled}
                    />
                </div>
            </div>
        </React.Fragment>
    );
});

export default observer(ProducerReportLayoutTemplate);
